import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'
import allMessages from '@/data/messages.js'

export default defineNuxtPlugin(() => {
  const locale = useEnv('locale')
  const messages = allMessages[locale]?.cookieConsent ?? allMessages.en.cookieConsent

  const updateGtagConsent = (cookie) => {
    if (typeof window.gtag !== 'function') return
    const accepted = cookie?.categories ?? []
    window.gtag('consent', 'update', {
      analytics_storage: accepted.includes('analytics') ? 'granted' : 'denied',
      ad_storage: accepted.includes('ads') ? 'granted' : 'denied',
      ad_user_data: accepted.includes('ads') ? 'granted' : 'denied',
      ad_personalization: accepted.includes('ads') ? 'granted' : 'denied',
    })
  }

  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: 'cloud inline',
        position: 'bottom right',
        equalWeightButtons: false,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {},
      ads: {},
    },

    onConsent: ({ cookie }) => updateGtagConsent(cookie),
    onChange: ({ cookie }) => updateGtagConsent(cookie),

    language: {
      default: locale,
      autoDetect: 'document',
      translations: {
        [locale]: {
          consentModal: messages.consentModal,
          preferencesModal: messages.preferencesModal,
        },
      },
    },
  })

  return {
    provide: {
      CookieConsent,
    },
  }
})
